export const CLOSED = 'closed';
export const SELECT = 'select';

export const DATE_FORMATS = {
    YYYY_MM_DD_HH_mm_ss: 'YYYY-MM-DD HH:mm:ss', // 2023-10-05 14:48:00
    YYYY_MM_DD: 'YYYY-MM-DD', // 2023-10-05
    TIME_24HOUR: 'HH:mm:ss A', // 02:48:00 PM
    MMMM_DD_YYYY: 'MMMM DD, YYYY', // October 05, 2023
    TIME_12HOUR: 'hh:mm:ss A', // 02:48:00 PM
    MM_DD_YYYY: 'MM/DD/YYYY', // 10/05/2023
};

export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const CALENDAR_CONSTANTS = {
    CLOSED,
    SELECT,
};
